/** For all fill colours except #ffffff or #cccccc return black colour #000000 */
export const FillOverrides = {
  '#ffffff': '#ffffff',
  '#cccccc': '#cccccc',
  '#000000': '#000000',
  default: '#000000',
} as const satisfies Record<(string & {}) | 'default', string>;
